import styled from 'styled-components'
import { SPACING, BORDER_RADIUS } from '../../../styles/theme'
import { SkeletonBox } from '../styles/SkeletonStyles'

const Page = styled.div`
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(135deg, var(--color-primary-bg) 0%, var(--color-bg-primary) 100%);
  position: relative;
`

const Card = styled.div`
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background: var(--color-bg-card);
  border-radius: 16px;
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xl};
`

const ProgressArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm};
`

const ProgressTrack = styled.div`
  height: 4px;
  background: var(--color-border);
  border-radius: 2px;
  overflow: hidden;
`

const ProgressFill = styled.div`
  height: 100%;
  width: 25%;
  background: var(--color-primary);
  border-radius: 2px;
`

const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm};
`

const OptionRow = styled.div`
  border: 1px solid var(--color-border);
  border-radius: ${BORDER_RADIUS.lg};
  padding: ${SPACING.md};
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
`

const NavButtons = styled.div`
  display: flex;
  gap: ${SPACING.md};
`

const OPTION_WIDTHS = [90, 110, 80, 100]

export function SkeletonSurveyOnboarding() {
  return (
    <Page>
      {/* Logo placeholder */}
      <SkeletonBox
        $width="100px"
        $height="22px"
        $radius={BORDER_RADIUS.sm}
        style={{ position: 'absolute', top: 24, left: 32 }}
      />

      <Card>
        {/* Title */}
        <SkeletonBox
          $width="140px"
          $height="24px"
          $radius={BORDER_RADIUS.sm}
          style={{ alignSelf: 'center' }}
        />

        {/* Progress bar */}
        <ProgressArea>
          <ProgressTrack>
            <ProgressFill />
          </ProgressTrack>
          <SkeletonBox
            $width="60px"
            $height="12px"
            $radius={BORDER_RADIUS.sm}
            style={{ alignSelf: 'center' }}
          />
        </ProgressArea>

        {/* Question */}
        <SkeletonBox
          $width="85%"
          $height="18px"
          $radius={BORDER_RADIUS.sm}
          style={{ alignSelf: 'center' }}
        />

        {/* Option rows */}
        <Options>
          {OPTION_WIDTHS.map((w, i) => (
            <OptionRow key={i}>
              <SkeletonBox
                $width="18px"
                $height="18px"
                $radius={BORDER_RADIUS.sm}
                style={{ flexShrink: 0 }}
              />
              <SkeletonBox $width={`${w}px`} $height="14px" $radius={BORDER_RADIUS.sm} />
            </OptionRow>
          ))}
        </Options>

        {/* Nav buttons */}
        <NavButtons>
          <SkeletonBox
            $width="100%"
            $height="40px"
            $radius={BORDER_RADIUS.sm}
            style={{ flex: 1 }}
          />
          <SkeletonBox
            $width="100%"
            $height="40px"
            $radius={BORDER_RADIUS.sm}
            style={{ flex: 2 }}
          />
        </NavButtons>
      </Card>
    </Page>
  )
}
